import Router from 'vue-router'
import { getAuthState } from './index'
// const subPage = {
//   template: '<router-view></router-view>'
// }

export default class extends Router {
  constructor (arg) {
    super(arg)
    this.map({
      '/login': {
        component: require('./components/pages/Login.vue'),
        noauth: true
        // noloading: true
      },
      '/production': {
        component: require('./components/pages/Production.vue')
      },
      '/firmware': {
        name: 'firmware',
        component: require('./components/pages/FwChangeLog.vue')
      },
      '/privateMIB': {
        component: require('./components/pages/Private_MIB.vue')
      },
      '/license': {
        component: require('./components/pages/License.vue')
      },
      '/mt-download': {
        component: require('./components/pages/FirmwareDownload.vue')
      }
    })
    this.beforeEach(({ to, next, abort }) => {
      if (to.matched === null) {
        // console.log('state is null')
        abort()
        this.replace('/firmware')
      } else if (to.noauth) {
        next()
      } else {
        getAuthState().then(state => {
          if (state) {
            return next()
          }
          abort()
          this.replace('/login')
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/Router.js